import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ChatbotDetails from "./ChatbotDetails";

const ChatbotSinglePage: React.FC = () => {
    useEffect(() => {
                        document.title = "AI Chatbot Virtual| Brain Machine AI";
                      }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="AI Chatbot Virtual" pagesub="AI Chatbot Virtual" />
                        <ChatbotDetails/>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default ChatbotSinglePage;
